import userReportsApi from '@/api/userreport.js'
import { mergeUserContext } from '@/store/helpers.js'

const userReportState = {
    userReportsByOrg: []
}

const getters = {
    getUserReportsByOrg: (state) => state.userReportsByOrg
}

const actions = {
    async getUserReportsByOrg ({ commit, rootState }, payload) {
        try {
            payload = mergeUserContext(payload, rootState)
            const response = await userReportsApi.getUserReports(payload)
            if (response.status !== 200) {
                throw response.body.error
            }

            commit('SET_USER_REPORTS_BY_ORG', response.body)
        } catch (error) {
            commit('SET_USER_REPORTS_BY_ORG', [])
        }
    }
}

const mutations = {
    SET_USER_REPORTS_BY_ORG (state, payload) {
        state.userReportsByOrg = payload
    }
}

export default {
    state: userReportState,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/userreport.js